import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { UserInfoService } from 'src/app/shared/services/user-info.service';
import { NoticeSnackbarComponent } from 'src/app/micro-components/notice-snackbar/notice-snackbar.component';

// Single source for the "report sent / failed" feedback shown after any report
// is triggered (query one-click + the report dialog's entity/portfolio/query
// sends). Keeps the copy and presentation in one place.
@Injectable({ providedIn: 'root' })
export class ReportFeedbackService {
  constructor(
    private snackBar: MatSnackBar,
    private userInfo: UserInfoService,
  ) {}

  reportSent(): void {
    const email = this.userInfo.email;
    NoticeSnackbarComponent.open(
      this.snackBar,
      {
        icon: 'mark_email_read',
        title: 'Your report is on its way',
        text:
          "We're generating it now and will email a download link in the next few minutes" +
          (email ? ` to ${email}.` : '.'),
        highlight: email,
      },
      9000,
    );
  }

  reportError(): void {
    NoticeSnackbarComponent.open(this.snackBar, {
      tone: 'error',
      title: 'The report could not be sent',
      text: 'The report request failed. Try again in a moment.',
    });
  }
}
